/* eslint-disable-next-line */
export function storeComplexSalesGuid(complexSalesGuid) {
  return {
    type: 'app.oneC.Query.storeComplexSalesGuid',
    payload: { complexSalesGuid },
  };
}
